import React from "react";
import LoadingButton from "./LoadingButton";
import "./QRCodesSection.css";

const QRCodesSection = ({ upload, loading }) => {
  return (
    <div className="qr-codes-section">
      <h3 className="qr-codes-section__title">QR codes and images</h3>
      <LoadingButton
        color="primary"
        variant="contained"
        className="qr-codes-section__button"
        onClick={upload("uploadArticleImages")}
        loading={loading}
      >
        Check
      </LoadingButton>
    </div>
  );
};

export default QRCodesSection;
